"use strict";

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPagesReducer;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _reduxResource = require("@flowio/redux-resource");

var _normalizeParameters2 = _interopRequireDefault(require("./normalizeParameters"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

function createPagesReducer() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // eslint-disable-next-line default-param-last
  return function pagesReducer() {
    var previousState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var _options$idAttribute = options.idAttribute,
        idAttribute = _options$idAttribute === void 0 ? 'id' : _options$idAttribute;

    var _normalizeParameters = (0, _normalizeParameters2.default)(action.meta),
        pageNumber = _normalizeParameters.pageNumber,
        pageSize = _normalizeParameters.pageSize;

    var resources = (0, _reduxResource.getResourcesArray)(action, {
      silent: !(0, _reduxResource.isFulfilledAction)(action)
    });
    var _previousState$pageNu = previousState[pageNumber],
        previousPage = _previousState$pageNu === void 0 ? {} : _previousState$pageNu;

    switch (action.type) {
      case _reduxResource.actionTypes.REQUEST_IDLE:
        return _objectSpread(_objectSpread({}, previousState), {}, (0, _defineProperty2.default)({}, pageNumber, _objectSpread(_objectSpread({}, previousPage), {}, {
          status: _reduxResource.readyState.IDLE
        })));

      case _reduxResource.actionTypes.REQUEST_PENDING:
        return _objectSpread(_objectSpread({}, previousState), {}, (0, _defineProperty2.default)({}, pageNumber, _objectSpread(_objectSpread({}, previousPage), {}, {
          status: _reduxResource.readyState.PENDING
        })));

      case _reduxResource.actionTypes.REQUEST_FULFILLED:
        return _objectSpread(_objectSpread({}, previousState), {}, (0, _defineProperty2.default)({}, pageNumber, _objectSpread(_objectSpread({}, previousPage), {}, {
          isFirstPage: pageNumber === 1,
          isLastPage: resources.length <= pageSize,
          // HACK: Due to limitations in Flow API, computing whether another page is
          // available is determined by checking whether another resource beyond the
          // desired limit is available.
          resources: resources.slice(0, pageSize).map(function (resource) {
            return resource[idAttribute];
          }),
          status: _reduxResource.readyState.FULFILLED
        })));

      case _reduxResource.actionTypes.REQUEST_REJECTED:
        return _objectSpread(_objectSpread({}, previousState), {}, (0, _defineProperty2.default)({}, pageNumber, _objectSpread(_objectSpread({}, previousPage), {}, {
          status: _reduxResource.readyState.REJECTED
        })));

      default:
        return previousState;
    }
  };
}